export default Object.freeze({
  Pending: 1,
  Sent: 2,
  Delivered: 3,
  Read: 4,
  Failed: 5,
  Error: 6,
  InQueue: 7,
  AIProcessing: 8,
  PolicyViolation: 9,
});
